// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Conversation_conversation__ij910 {
  display: grid;
  grid-template-rows: 58px auto 58px;
  grid-template-columns: 100%;
  height: 100%;
  width: 100%;
  background-color: white;
}
@media screen and (min-width: 600px) {
  .Conversation_conversation__ij910 {
    border-left: 1px solid rgb(216, 216, 216);
  }
}
@media screen and (max-width: 600px) {
  .Conversation_conversation__ij910 {
    position: fixed;
    left: 0;
    top: 0;
    height: calc(100% - 47px);
    width: 100vw;
    z-index: 10;
    animation: Conversation_slide-into-view__NXWC8 0.3s cubic-bezier(0, 0.68, 0.54, 0.99);
  }
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl {
  border-bottom: rgb(216, 216, 216) 1px solid;
  width: 100%;
  height: 100%;
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl a {
  text-decoration: none;
  color: inherit;
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl .Conversation_close-icon__zrl2U {
  position: relative;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl .Conversation_close-icon__zrl2U div {
  position: absolute;
  width: 3px;
  height: 25px;
  background-color: black;
  border-radius: 2px;
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl .Conversation_close-icon__zrl2U div:nth-child(1) {
  transform: rotate(45deg);
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl .Conversation_close-icon__zrl2U div:nth-child(2) {
  transform: rotate(-45deg);
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl .Conversation_user-details__QFGtM {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 1.3em;
  font-weight: 500;
}
.Conversation_conversation__ij910 .Conversation_header__CYXGl .Conversation_user-details__QFGtM .Conversation_user-name__2KhOl {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 5px;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn {
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  overflow: scroll;
  padding: 5px 10px;
  position: relative;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_message__brn3\\+ {
  background-color: rgb(216, 216, 216);
  margin: 4px;
  padding: 10px 15px;
  border-radius: 15px;
  max-width: 70%;
  width: -moz-fit-content;
  width: fit-content;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_message__brn3\\+ p {
  margin: 0;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_message__brn3\\+ .Conversation_lower__wPnPX {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-top: 3px;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_message__brn3\\+ .Conversation_lower__wPnPX span {
  font-size: 0.7em;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_sent-by-me__VQHu8 {
  align-self: flex-end;
  background-color: var(--accent-color-xxx-light);
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_preceded-by-similar__8xKX\\+ {
  margin-bottom: 2px;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_followed-by-similar__DGfZS {
  margin-top: 2px;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_sent-by-me__VQHu8.Conversation_followed-by-similar__DGfZS {
  border-top-right-radius: 3px;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_sent-by-me__VQHu8.Conversation_preceded-by-similar__8xKX\\+ {
  border-bottom-right-radius: 3px;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_sent-by-other__13f87.Conversation_followed-by-similar__DGfZS {
  border-top-left-radius: 3px;
}
.Conversation_conversation__ij910 .Conversation_messages-list__OKEfn .Conversation_sent-by-other__13f87.Conversation_preceded-by-similar__8xKX\\+ {
  border-bottom-left-radius: 3px;
}
.Conversation_conversation__ij910 .Conversation_message-input__V56Kc {
  border-top: rgb(216, 216, 216) 1px solid;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
}
.Conversation_conversation__ij910 .Conversation_message-input__V56Kc input {
  width: calc(100% - 50px);
  height: 100%;
  border-radius: 20px;
  border: none;
  background-color: rgb(226, 226, 226);
  padding: 10px 20px;
}
.Conversation_conversation__ij910 .Conversation_message-input__V56Kc button {
  padding: 5px;
  border-radius: 30px;
  border: none;
  background-color: transparent;
}
.Conversation_conversation__ij910 .Conversation_message-input__V56Kc button svg {
  height: 35px;
  width: 35px;
  fill: var(--accent-color);
}
.Conversation_conversation__ij910 .Conversation_message-input__V56Kc button:hover svg {
  fill: var(--accent-color-dark);
}
.Conversation_conversation__ij910 .Conversation_message-input__V56Kc button:active svg {
  fill: var(--accent-color-x-dark);
}
.Conversation_conversation__ij910 .Conversation_message-input__V56Kc button:disabled svg {
  fill: grey;
}

@keyframes Conversation_slide-into-view__NXWC8 {
  0% {
    left: 100vw;
  }
  100% {
    left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Messages/Conversation/Conversation.module.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,kCAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AACH;AACG;EARH;IASM,yCAAA;EAEJ;AACF;AAAG;EAZH;IAaM,eAAA;IACA,OAAA;IACA,MAAA;IACA,yBAAA;IACA,YAAA;IACA,WAAA;IACA,qFAAA;EAGJ;AACF;AADG;EAEG,2CAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AAEN;AAAM;EACG,qBAAA;EACA,cAAA;AAET;AACM;EACG,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACT;AAES;EACG,kBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAAZ;AAGS;EACG,wBAAA;AADZ;AAIS;EACG,yBAAA;AAFZ;AAMM;EACG,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAJT;AAMS;EACG,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAJZ;AAUG;EACG,YAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AARN;AAUM;EACG,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EAAA,kBAAA;AART;AAUS;EACG,SAAA;AARZ;AAWS;EACG,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,eAAA;AATZ;AAWY;EACG,gBAAA;AATf;AAeM;EACG,oBAAA;EACA,+CAAA;AAbT;AAgBM;EACG,kBAAA;AAdT;AAiBM;EACG,eAAA;AAfT;AAkBM;EACG,4BAAA;AAhBT;AAmBM;EACG,+BAAA;AAjBT;AAoBM;EACG,2BAAA;AAlBT;AAqBM;EACG,8BAAA;AAnBT;AAuBG;EAEG,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAtBN;AAwBM;EACG,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AAtBT;AAyBM;EACG,YAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AAvBT;AAyBS;EACG,YAAA;EACA,WAAA;EACA,yBAAA;AAvBZ;AA4BS;EACG,8BAAA;AA1BZ;AA+BS;EACG,gCAAA;AA7BZ;AAkCS;EACG,UAAA;AAhCZ;;AAsCA;EACG;IACG,WAAA;EAnCJ;EAsCC;IACG,OAAA;EApCJ;AACF","sourcesContent":[".conversation {\n   display: grid;\n   grid-template-rows: 58px auto 58px;\n   grid-template-columns: 100%;\n   height: 100%;\n   width: 100%;\n   background-color: white;\n\n   @media screen and (min-width: 600px) {\n      border-left: 1px solid rgb(216, 216, 216);\n   }\n\n   @media screen and (max-width: 600px) {\n      position: fixed;\n      left: 0;\n      top: 0;\n      height: calc(100% - 47px);\n      width: 100vw;\n      z-index: 10;\n      animation: slide-into-view 0.3s cubic-bezier(0, .68, .54, .99);\n   }\n\n   .header {\n      // box-shadow: var(--shadow);\n      border-bottom: rgb(216, 216, 216) 1px solid;\n      width: 100%;\n      height: 100%;\n      color: black;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n      padding: 10px;\n\n      a {\n         text-decoration: none;\n         color: inherit;\n      }\n\n      .close-icon {\n         position: relative;\n         height: 40px;\n         width: 40px;\n         display: flex;\n         align-items: center;\n         justify-content: center;\n\n\n         div {\n            position: absolute;\n            width: 3px;\n            height: 25px;\n            background-color: black;\n            border-radius: 2px;\n         }\n\n         div:nth-child(1) {\n            transform: rotate(45deg);\n         }\n\n         div:nth-child(2) {\n            transform: rotate(-45deg);\n         }\n      }\n\n      .user-details {\n         display: flex;\n         flex-direction: row;\n         align-items: center;\n         font-size: 1.3em;\n         font-weight: 500;\n\n         .user-name {\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            margin: 5px;\n            // max-width: calc(100% - 100px);\n         }\n      }\n   }\n\n   .messages-list {\n      height: 100%;\n      display: flex;\n      flex-direction: column-reverse;\n      overflow: scroll;\n      padding: 5px 10px;\n      position: relative;\n\n      .message {\n         background-color: rgb(216, 216, 216);\n         margin: 4px;\n         padding: 10px 15px;\n         border-radius: 15px;\n         max-width: 70%;\n         width: fit-content;\n\n         p {\n            margin: 0;\n         }\n\n         .lower {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            width: 100%;\n            justify-content: space-between;\n            margin-top: 3px;\n\n            span {\n               font-size: 0.7em;\n               // color: rgb(75, 75, 75);\n            }\n         }\n      }\n\n      .sent-by-me {\n         align-self: flex-end;\n         background-color: var(--accent-color-xxx-light);\n      }\n\n      .preceded-by-similar {\n         margin-bottom: 2px;\n      }\n\n      .followed-by-similar {\n         margin-top: 2px;\n      }\n\n      .sent-by-me.followed-by-similar {\n         border-top-right-radius: 3px;\n      }\n\n      .sent-by-me.preceded-by-similar {\n         border-bottom-right-radius: 3px;\n      }\n\n      .sent-by-other.followed-by-similar {\n         border-top-left-radius: 3px;\n      }\n\n      .sent-by-other.preceded-by-similar {\n         border-bottom-left-radius: 3px;\n      }\n   }\n\n   .message-input {\n      // box-shadow: var(--shadow);\n      border-top: rgb(216, 216, 216) 1px solid;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n      padding: 8px 10px;\n\n      input {\n         width: calc(100% - 50px);\n         height: 100%;\n         border-radius: 20px;\n         border: none;\n         background-color: rgb(226, 226, 226);\n         padding: 10px 20px;\n      }\n\n      button {\n         padding: 5px;\n         border-radius: 30px;\n         border: none;\n         background-color: transparent;\n\n         svg {\n            height: 35px;\n            width: 35px;\n            fill: var(--accent-color);\n         }\n      }\n\n      button:hover {\n         svg {\n            fill: var(--accent-color-dark);\n         }\n      }\n\n      button:active {\n         svg {\n            fill: var(--accent-color-x-dark);\n         }\n      }\n\n      button:disabled {\n         svg {\n            fill: grey;\n         }\n      }\n   }\n}\n\n@keyframes slide-into-view {\n   0% {\n      left: 100vw;\n   }\n\n   100% {\n      left: 0;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"conversation": `Conversation_conversation__ij910`,
	"slide-into-view": `Conversation_slide-into-view__NXWC8`,
	"header": `Conversation_header__CYXGl`,
	"close-icon": `Conversation_close-icon__zrl2U`,
	"user-details": `Conversation_user-details__QFGtM`,
	"user-name": `Conversation_user-name__2KhOl`,
	"messages-list": `Conversation_messages-list__OKEfn`,
	"message": `Conversation_message__brn3+`,
	"lower": `Conversation_lower__wPnPX`,
	"sent-by-me": `Conversation_sent-by-me__VQHu8`,
	"preceded-by-similar": `Conversation_preceded-by-similar__8xKX+`,
	"followed-by-similar": `Conversation_followed-by-similar__DGfZS`,
	"sent-by-other": `Conversation_sent-by-other__13f87`,
	"message-input": `Conversation_message-input__V56Kc`
};
export default ___CSS_LOADER_EXPORT___;
